import environment from "../environment";
import { POST } from "./http.service";

const _token = environment.TOKEN_KEY;

export const joinSession = async (id) => {
  const response = await POST(
    `CourseSession/${id}/join`,
    null,
    localStorage.getItem(_token)
  );
  return response;
};

export const joinSession2 = async (id) => {
  const response = await POST(
    `CourseSession/${id}/meeting`,
    null,
    localStorage.getItem(_token)
  );
  return response;
};


export const joinActivity = async (id) => {
  const response = await POST(
    `Workshop/${id}/join`,
    null,
    localStorage.getItem(_token)
  );
  return response;
};
